import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "../api";

export function AdminResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    if (password !== confirm) { setError("Passwords do not match."); return; }
    if (password.length < 8) { setError("Password must be at least 8 characters."); return; }
    setError(""); setLoading(true);
    try {
      await api.adminResetPasswordViaToken({ token, password });
      setSuccess(true);
      setTimeout(() => navigate("/admin/login"), 2000);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  if (!token) return (
    <div className="auth-shell">
      <div className="auth-panel-left">
        <div className="auth-brand">
          <img src="/logo.jpg" alt="Cow Town Redi Mix" />
          <div className="auth-brand-name">Admin Portal</div>
        </div>
      </div>
      <div className="auth-panel-right">
        <div className="auth-form-wrap">
          <div className="alert alert-error">Invalid reset link.</div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="auth-shell">
      <div className="auth-panel-left">
        <div className="auth-brand">
          <img src="/logo.jpg" alt="Cow Town Redi Mix" />
          <div className="auth-brand-name">Admin Portal</div>
          <div className="auth-brand-tagline">CowTown Redi Mix — Staff Access Only</div>
        </div>
      </div>
      <div className="auth-panel-right">
        <div className="auth-form-wrap">
          <div className="auth-form-title">Set New Password</div>
          <div className="auth-form-sub">Enter a new password for your admin account.</div>
          {success ? (
            <div className="alert alert-success">Password updated! Redirecting to sign in...</div>
          ) : (
            <>
              {error && <div className="alert alert-error">{error}</div>}
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label className="form-label">New Password</label>
                  <input className="form-input" type="password" value={password}
                    onChange={e => setPassword(e.target.value)} required minLength={8} autoFocus
                    placeholder="Minimum 8 characters" />
                </div>
                <div className="form-group">
                  <label className="form-label">Confirm New Password</label>
                  <input className="form-input" type="password" value={confirm}
                    onChange={e => setConfirm(e.target.value)} required minLength={8} />
                </div>
                <button className="btn btn-primary" style={{ width: "100%", justifyContent: "center" }}
                  type="submit" disabled={loading}>
                  {loading ? "Updating..." : "Update Password"}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
